import { SET_ACCESS_LEVEL } from "../contents/actionsTypes";

const initialState = {
  level: null,
};

const accessLevelReducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case SET_ACCESS_LEVEL:
      return {
        ...state,
        level: payload,
      };
    default:
      return state;
  }
};

export default accessLevelReducer;
